import { transparentize, darken } from 'polished'
import styled, { css, keyframes } from 'styled-components'

import { THEME, THEMES, transformToREM } from '../../styles'

const linearGradient = ({ theme, fill } = {}) => {
  const THEME = THEMES[theme] || THEMES.light
  return `
    linear-gradient(
      to right,
      ${darken(0.2, transparentize(1, fill || THEME.background.primary))} 0%,
      ${darken(0.2, transparentize(0.8, fill || THEME.background.primary))} 20%,
      ${darken(0.2, transparentize(0.5, fill || THEME.background.primary))} 60%,
      ${darken(0.2, transparentize(1, fill || THEME.background.primary))} 100%
    );
  `
}

const pulse = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
`

const wave = keyframes`
  0% {
    transform: translateX(-100%);
  }
  50% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(100%);
  }
`

const getVariantStyles = (variant) => {
  switch (variant) {
    case 'text':
      return css`
        margin: 0;
        border-radius: 9999px;
        transform-origin: 0 55%;

        &:empty:before {
          content: ' ';
          height: 100%;
        }
      `
    case 'circular':
      return css`
        border-radius: 9999px;
      `
    case 'rectangular':
      return css`
        border-radius: 0.2rem;
      `
    default:
      return ''
  }
}

const getAnimation = ({ animation, theme, fill } = {}) => {
  switch (animation) {
    case 'wave':
      return css`
        position: relative;
        overflow: hidden;
        cursor: wait;

        &:after {
          animation: ${wave} 1.6s linear 0.8s infinite;
          background: ${linearGradient({ theme, fill })};
          content: '';
          position: absolute;

          /* Avoid flash during server-side hydration */
          transform: translateX(-100%);
          inset: 0;
          height: 100%;
        }
      `
    case 'pulse':
      return css`
        animation: ${pulse} 1.6s ease-in-out 0.5s infinite;
      `
    default:
      return ''
  }
}

const Styled = styled.div`
  display: block;
  height: 1.6rem;
  background-color: ${({ $skeletonFill }) =>
    $skeletonFill || THEME.COLORS.background.primary};

  ${({ $skeletonAnimation, $currentTheme, $skeletonFill }) =>
    getAnimation({
      animation: $skeletonAnimation,
      theme: $currentTheme,
      fill: $skeletonFill,
    })};
  ${({ $skeletonVariant }) => getVariantStyles($skeletonVariant)};
  ${({ $skeletonHeight }) =>
    $skeletonHeight ? `height: ${transformToREM($skeletonHeight)};` : ''};
  ${({ $skeletonWidth }) =>
    $skeletonWidth ? `width: ${transformToREM($skeletonWidth)};` : ''};

  &:not(:empty) {
    ${({ skeletonHeight, skeletonWidth }) => css`
      & > * {
        visibility: hidden;
      }
      ${skeletonHeight ? '' : 'height: auto;'};
      ${skeletonWidth ? '' : 'max-width: fit-content;'};
    `}
  }
`

export default Styled
